export const IconWhiteRefresh: {
  name: 'icon_white_refresh-8d5c2109dd26'
} = {
  name: 'icon_white_refresh-8d5c2109dd26'
}
